import { EffectivePermissions, PermissionOverride } from '../types/permissions';
import { Role } from '../types';

const AWS_BASE = process.env.REACT_APP_API_URL || 'https://api.intrlock.io';

function baseUrl() {
  return AWS_BASE;
}

function headers(): HeadersInit {
  const token = localStorage.getItem('intrlock_token') || '';
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
}

async function apiFetch(path: string, options: RequestInit = {}): Promise<any> {
  const res = await fetch(`${baseUrl()}${path}`, {
    ...options,
    headers: { ...headers(), ...(options.headers || {}) },
  });
  if (!res.ok) {
    // Do NOT auto-logout on permissions 401 — a stale/mismatched permissions
    // Lambda shouldn't nuke the session. apiClient.ts still auto-logs-out on
    // /auth/* 401 which is the authoritative session-expiry signal.
    const text = await res.text().catch(() => '');
    throw new Error(`Permissions API error ${res.status}: ${text}`);
  }
  return res.json();
}

export async function getMyPermissions(): Promise<EffectivePermissions> {
  return apiFetch('/permissions/me');
}

export async function getRolePermissions(role: Role): Promise<PermissionOverride[]> {
  const data = await apiFetch(`/permissions/role/${role}`);
  return data.permissions || [];
}

export async function updateRolePermissions(role: Role, permissions: PermissionOverride[]): Promise<void> {
  await apiFetch(`/permissions/role/${role}`, {
    method: 'PUT',
    body: JSON.stringify({ permissions }),
  });
}

export async function getUserPermissions(userId: number | string): Promise<PermissionOverride[]> {
  const data = await apiFetch(`/permissions/user/${userId}`);
  return data.permissions || [];
}

export async function updateUserPermissions(userId: number | string, permissions: PermissionOverride[]): Promise<void> {
  await apiFetch(`/permissions/user/${userId}`, {
    method: 'PUT',
    body: JSON.stringify({ permissions }),
  });
}

export async function clearUserPermissions(userId: number | string): Promise<void> {
  await apiFetch(`/permissions/user/${userId}`, { method: 'DELETE' });
}
